import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api, mediaUrl } from "@/lib/api";

const Reel = ({ r, i }) => (
  <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
    className="snap-center shrink-0 w-[72%] sm:w-[45%] md:w-auto">
    <div className="relative aspect-[9/16] rounded-3xl overflow-hidden sticker bg-[#18072D]" data-testid={`reel-${i}`}>
      <video src={mediaUrl(r.src)} autoPlay muted loop playsInline preload="metadata" disablePictureInPicture
        controlsList="nodownload" onContextMenu={(e) => e.preventDefault()}
        className="w-full h-full object-cover" data-testid={`reel-video-${i}`} />
      {r.title && <p className="absolute bottom-0 inset-x-0 p-4 text-sm font-semibold text-white bg-gradient-to-t from-black/60 to-transparent">{r.title}</p>}
    </div>
  </motion.div>
);

export const StudentReels = () => {
  const [reels, setReels] = useState([]);
  useEffect(() => { api.get("/reels").then((r) => setReels(r.data)).catch(() => {}); }, []);
  if (!reels.length) return null;
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 py-20" data-testid="home-reels-section">
      <h2 className="font-display text-4xl sm:text-5xl text-ink mb-10">أعمال <span className="text-brand">المتدربين</span></h2>
      <div className="flex md:grid md:grid-cols-3 gap-5 md:gap-8 overflow-x-auto md:overflow-visible snap-x snap-mandatory pb-4 md:pb-0 -mx-4 px-4 md:mx-0 md:px-0">
        {reels.slice(0, 3).map((r, i) => <Reel key={r.id} r={r} i={i} />)}
      </div>
    </section>
  );
};
